module.exports = __webpack_public_path__ + "9d3767a05ae0574772dc3d0b485934f1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/logo1.png
 ** module id = 209
 ** module chunks = 1
 **/